import React, { forwardRef } from 'react'
import { clsx } from 'clsx'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string
  label?: string
  helperText?: string
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  error,
  label,
  helperText,
  className,
  ...props
}, ref) => {
  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <input
        ref={ref}
        className={clsx(
          'w-full px-3 py-2 border rounded-lg transition-colors duration-200',
          'focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent',
          {
            'border-gray-300 hover:border-gray-400': !error,
            'border-red-500 focus:ring-red-500': error,
          },
          className
        )}
        {...props}
      />
      {(error || helperText) && (
        <div className={clsx('text-sm', {
          'text-red-600': error,
          'text-gray-500': !error && helperText,
        })}>
          {error || helperText}
        </div>
      )}
    </div>
  )
})